var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconImprovementChangesPkdl5F48G9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270.6 270.6",
    enableBackground: "new 0 0 270.6 270.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KEY_ACCOUNT_MANAGEMENT"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TIME_MANAGEMENT"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SOCIAL_NETWORK"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SOCIAL_MEDIA"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "REFERRAL_MARKETING"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SEARCH_ANALYTICS"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "STARTUP"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SEARCH_ENGINE_MARKETING"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5EB4E7",
    width: 270.6,
    height: 270.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2E95D1",
    d: "M80.7,85.8L68.1,98.3l10.2,12.1c-3.3,4.9-5.7,10.3-7,15.8l-16.3,1.4l0,17.8l15.8,1.3 c1.1,5.6,3.2,11.1,6.2,16.1l-10.6,12.5l12.6,12.6l12.1-10.2c4.9,3.3,10.3,5.7,15.8,7l1.4,16.3l17.8,0l1.3-15.8 c5.6-1.1,11.1-3.2,16.1-6.2l12.5,10.6l12.6-12.6l-10.2-12.1c3.3-4.9,5.7-10.3,7-15.8l16.3-1.4l0-17.8l-15.8-1.3 c-1.1-5.6-3.2-11.1-6.2-16.1l10.6-12.5l-12.6-12.6l-12.1,10.2c-4.9-3.3-10.3-5.7-15.8-7l-1.4-16.3l-17.8,0l-1.3,15.8 c-5.6,1.1-11.1,3.2-16.1,6.2L80.7,85.8z M132.3,123.6c7.7,7.7,7.7,20.2,0,27.9c-7.7,7.7-20.2,7.7-27.9,0 c-7.7-7.7-7.7-20.2,0-27.9C112.2,115.9,124.6,116,132.3,123.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M184.7,175.7c-4.2,0-7.7-3.4-7.7-7.7c0-4.2,3.4-7.7,7.7-7.7s7.7,3.4,7.7,7.7 C192.4,172.3,189,175.7,184.7,175.7z M184.7,164.4c-2,0-3.7,1.6-3.7,3.7c0,2,1.6,3.7,3.7,3.7s3.7-1.6,3.7-3.7 C188.4,166,186.8,164.4,184.7,164.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.7,
    y: 155.8,
    fill: "#282D33",
    width: 4,
    height: 5.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.7,
    y: 174.9,
    fill: "#282D33",
    width: 4,
    height: 5.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.7,
    y: 161.2,
    transform: "matrix(0.866 0.5 -0.5 0.866 105.2514 -66.3395)",
    fill: "#282D33",
    width: 5.4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.3,
    y: 170.8,
    transform: "matrix(0.866 0.5 -0.5 0.866 112.2669 -73.355)",
    fill: "#282D33",
    width: 5.4,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.4,
    y: 170.1,
    transform: "matrix(0.4999 0.8661 -0.8661 0.4999 237.9075 -66.3684)",
    fill: "#282D33",
    width: 4,
    height: 5.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 160.6,
    transform: "matrix(0.4999 0.8661 -0.8661 0.4999 237.9082 -85.5376)",
    fill: "#282D33",
    width: 4,
    height: 5.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "165.5,129.9 151.7,116.1 147.4,120.5 144.5,117.7 151.7,110.5 165.5,124.2 221.9,67.8  224.7,70.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.9,
    y: 123,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 136.1035 -46.2255)",
    fill: "#FFFFFF",
    width: 4,
    height: 36.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "225.3,86.9 221.3,86.9 221.3,71.2 205.7,71.2 205.7,67.2 225.3,67.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "209.9,128.7 205.9,128.7 205.9,113.1 190.3,113.1 190.3,109.1 209.9,109.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "168.3,153.6 128.9,114.2 101.4,141.6 98.6,138.8 128.9,108.5 168.3,147.9 206.5,109.7  209.3,112.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M74.8,82.4V59.1c-12.7,0.8-22.8,10.6-23.9,23.3H74.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M54.4,109.3c-6.9-6.3-10.9-15.2-10.9-24.5c0-17.7,13.8-32.2,31.5-33l0.2,4c-15.5,0.7-27.7,13.5-27.7,29 c0,8.2,3.5,16,9.6,21.6L54.4,109.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M76.4,117.8c-5.8,0-11.5-1.5-16.5-4.4l-2-1.1l20.8-27.2V51.7L81,52c16.3,2.2,28.5,16.3,28.5,32.8 C109.5,103,94.6,117.8,76.4,117.8z M63.9,111c3.9,1.9,8.2,2.8,12.5,2.8c16,0,29.1-13,29.1-29.1c0-13.7-9.6-25.5-22.8-28.4v30.1 L63.9,111z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E95D1",
    d: "M72.2,86.3c-3.1,4-8.3,10.7-13.3,17.2c-0.2-0.2-0.4-0.3-0.6-0.5c-4.5-4.5-7.1-10.4-7.5-16.7H72.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M118.4,159.3c-5.8,0-11.2-2.3-15.3-6.4c-4.1-4.1-6.4-9.6-6.4-15.4s2.3-11.3,6.4-15.4l2.8,2.8 c-3.3,3.3-5.2,7.8-5.2,12.5s1.8,9.2,5.2,12.5c3.3,3.3,7.8,5.2,12.5,5.2c0,0,0,0,0,0c4.7,0,9.2-1.8,12.5-5.2l2.8,2.8 C129.6,157,124.2,159.3,118.4,159.3C118.4,159.3,118.4,159.3,118.4,159.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.4,169.7c-8.6,0-16.6-3.3-22.7-9.4s-9.4-14.1-9.4-22.7h4c0,7.5,2.9,14.6,8.2,19.9 c5.3,5.3,12.4,8.2,19.9,8.2V169.7z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "MARKETING_STRATEGY"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "MARKETING_PLAN"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "MARKET_RESEARCH"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "STATISTICS"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "INTERNET_MARKETING"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "MOBILE_MARKETING"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "VIDEO_ADVERTISING"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "EMAIL_MARKETING"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconImprovementChangesPkdl5F48G9);
export default __webpack_public_path__ + "static/media/reshot-icon-improvement-changes-PKDL5F48G9.8552d17106f61596bbc49e297bc9df93.svg";
export { ForwardRef as ReactComponent };